import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setServices } from "@/redux/actions"

interface ModuleLoadingState {
  isLoading: boolean
  error: string | null
  progress: number
}

/**
 * Hook para cargar módulos de forma diferida y no bloquear la UI inicial
 * Ahora solo actualiza servicios si hay cambios, ya que todos se cargan en App.tsx
 */
export const useLazyModules = (delay: number = 1000) => {
  const [loadingState, setLoadingState] = useState<ModuleLoadingState>({
    isLoading: false,
    error: null,
    progress: 0,
  })

  const dispatch = useDispatch()
  const currentServices = useSelector((state: any) => state.services)

  useEffect(() => {
    // Los módulos ya fueron cargados en App.tsx (loadCriticalServices).
    // Este hook solo reporta el estado de carga basándose en el store de Redux,
    // sin hacer una segunda llamada al backend.
    if (currentServices && Object.keys(currentServices).length > 0) {
      setLoadingState({ isLoading: false, error: null, progress: 100 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return loadingState
}

/**
 * Hook para precargar recursos críticos
 */
export const usePreloadCriticalResources = () => {
  useEffect(() => {
    // Precargar imágenes críticas del splash screen
    const preloadImages = () => {
      const criticalImages = [
        "/src/assets/outpoints-logo.png",
        "/src/assets/imagotipo-white.svg",
      ]

      criticalImages.forEach((src) => {
        const link = document.createElement("link")
        link.rel = "preload"
        link.as = "image"
        link.href = src
        document.head.appendChild(link)
      })
    }

    // Precargar fuentes críticas
    const preloadFonts = () => {
      const fontLink = document.createElement("link")
      fontLink.rel = "preload"
      fontLink.as = "font"
      fontLink.type = "font/woff2"
      fontLink.crossOrigin = "anonymous"
      fontLink.href = "/src/assets/FontInter-ZO3WBJgw.ttf"
      document.head.appendChild(fontLink)
    }

    preloadImages()
    preloadFonts()
  }, [])
}
